module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/mail-1e25f4be65894e6260faf5fb575527f6.svg";